/**
 * The API identifies records by a base64 global IDType ("MWUtMzMy" decodes to
 * "1e-332"), while admin routes are keyed by the numeric oid. Note oids can be
 * negative on seeded/imported content, so the pattern allows a leading '-'.
 */
export const globalIdToOid = (id: string | number | null | undefined): string => {
  const value = String(id ?? '');
  if (!value) return '';
  if (/^-?\d+$/.test(value)) return value; // already an oid

  try {
    const match = atob(value).match(/-?\d+$/);
    return match ? match[0] : value;
  } catch {
    return value;
  }
};

/** Admin edit route for an article, given either an oid or a global id. */
export const articleEditPath = (id: string | number | null | undefined): string =>
  `/editorial/articles/${globalIdToOid(id)}`;
